export { default } from './use-local-storage';
